"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = exports.NumericalUnit = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const big_js_1 = __importDefault(require("big.js"));
const core_2 = require("@material-ui/core");
const Theme_1 = __importDefault(require("../styles/Theme"));
var NumericalUnit;
(function (NumericalUnit) {
    NumericalUnit["DOLLARS"] = "$";
    NumericalUnit["EACH"] = "each";
    NumericalUnit["FLOZ"] = "fl-oz";
    NumericalUnit["G"] = "g";
    NumericalUnit["GAL"] = "gal";
    NumericalUnit["KG"] = "kg";
    NumericalUnit["L"] = "l";
    NumericalUnit["LB"] = "lb";
    NumericalUnit["MG"] = "mg";
    NumericalUnit["ML"] = "ml";
    NumericalUnit["OZ"] = "oz";
    NumericalUnit["PT"] = "pt";
    NumericalUnit["QT"] = "qt";
})(NumericalUnit = exports.NumericalUnit || (exports.NumericalUnit = {}));
exports.NumberInput = (props) => {
    const { allowDecimals = true, decimalPlaces = 2, dirty: hasBeenSubmitted = false, endAdornment, handleError, label, maximum, minimum, onChange, required = false, startAdornment, step, units, value } = props, textFieldProps = __rest(props, ["allowDecimals", "decimalPlaces", "dirty", "endAdornment", "handleError", "label", "maximum", "minimum", "onChange", "required", "startAdornment", "step", "units", "value"]);
    const [error, setError] = react_1.useState(false);
    const [errorMessage, setErrorMessage] = react_1.useState();
    const [dirty, setDirty] = react_1.useState(hasBeenSubmitted);
    const getIsDivisibleByStep = (inputNumber) => {
        if (inputNumber == null || Number.isNaN(inputNumber)) {
            return true;
        }
        const precision = new big_js_1.default(.1).pow(decimalPlaces);
        const defaultStep = allowDecimals ? precision : 1;
        const stepToUse = step || defaultStep;
        return Number(new big_js_1.default(inputNumber).mod(stepToUse)) === 0;
    };
    const handleInput = (inputEvent) => {
        setDirty(true);
        const input = inputEvent.target.value;
        if (onChange) {
            onChange(input);
        }
    };
    const validateInput = (input) => {
        const inputNumber = parseFloat(input || '');
        const inputIsNullAndIsValid = (input == null || input === '') && required === false;
        if (inputNumber === NaN) {
            setErrorMessage(`Input for ${label} is not a valid number`);
        }
        else {
            const inputSplitBySeperator = lodash_1.default.split(input || '', '.');
            const inputIsRequiredAndIsEmpty = {
                errorStatus: required && dirty && (input == null || input === ''),
                errorMessage: `is required`
            };
            // More than one decimal point
            const inputHasMoreThanOneDecimalPoint = {
                errorStatus: inputSplitBySeperator.length > 2
                    && !inputIsNullAndIsValid,
                errorMessage: `has two or more decimal points`
            };
            // Uses fractions when it shouldn't
            const inputHasDecimalsAndItShouldNot = {
                errorStatus: allowDecimals === false
                    && lodash_1.default.includes(input, '.')
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `is not a whole number`,
            };
            // Has too many decimal places
            const inputHasToHighOfPrecision = {
                errorStatus: allowDecimals === true
                    && inputSplitBySeperator.length > 1
                    && inputSplitBySeperator[1].length > decimalPlaces
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `has too many decimal places, more than the maximum of ${decimalPlaces}`
            };
            // Is over maximum
            const inputIsOverMaximum = {
                errorStatus: maximum != null
                    && inputNumber > maximum
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `is over the maximum allowed value of ${maximum}`
            };
            // Is under minimum
            const inputIsUnderMinimum = {
                errorStatus: minimum != null
                    && inputNumber < minimum
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `is under the minimum allowed value of ${minimum}`
            };
            // Is not divisible by Step
            const inputIsNotDivisibleByStep = {
                errorStatus: step != null
                    && getIsDivisibleByStep(inputNumber) === false
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `is not divisible by ${step} as required`
            };
            // Isn't a number, also returns false for NaN inputs
            const inputIsAValidNumber = {
                errorStatus: lodash_1.default.isFinite(inputNumber) === false
                    && !inputIsNullAndIsValid
                    && dirty,
                errorMessage: `is not a valid number`,
            };
            const checks = [
                inputIsRequiredAndIsEmpty,
                inputHasMoreThanOneDecimalPoint,
                inputHasDecimalsAndItShouldNot,
                inputHasToHighOfPrecision,
                inputIsOverMaximum,
                inputIsUnderMinimum,
                inputIsNotDivisibleByStep,
                inputIsAValidNumber,
            ];
            const errorsPresent = lodash_1.default.filter(checks, (check) => {
                return check.errorStatus;
            });
            const inputIsInvalid = errorsPresent.length > 0;
            if (inputIsInvalid) {
                const allMessages = lodash_1.default.map(errorsPresent, (errorPresent) => {
                    return errorPresent.errorMessage;
                });
                const errorMessage = inputIsRequiredAndIsEmpty.errorStatus ? `${label} is required` : `Input of ${input} is invalid, it ${allMessages.join(', and ')}`;
                setErrorMessage(errorMessage);
            }
            else {
                setErrorMessage('');
            }
        }
    };
    react_1.useEffect(() => {
        validateInput(value);
    }, [dirty, value, required]);
    react_1.useEffect(() => {
        if (handleError) {
            handleError(error, errorMessage);
        }
    }, [error]);
    react_1.useEffect(() => {
        if (errorMessage === '' || errorMessage == null) {
            setError(false);
        }
        else {
            setError(true);
        }
    }, [errorMessage]);
    react_1.useEffect(() => {
        setDirty(hasBeenSubmitted);
    }, [hasBeenSubmitted]);
    const getInputAdornments = () => {
        let start;
        let end;
        if (startAdornment) {
            start = startAdornment;
        }
        else if (units === NumericalUnit.DOLLARS) {
            start = react_1.default.createElement(core_1.InputAdornment, { position: 'start' }, "$");
        }
        if (endAdornment) {
            end = endAdornment;
        }
        else if (units !== undefined && units !== NumericalUnit.DOLLARS) {
            end = react_1.default.createElement(core_1.InputAdornment, { position: 'end' }, units);
        }
        return {
            endAdornment: end,
            startAdornment: start,
        };
    };
    return (react_1.default.createElement(core_2.MuiThemeProvider, { theme: Theme_1.default },
        react_1.default.createElement("div", { className: 'input-container' },
            react_1.default.createElement(TextField_1.default, Object.assign({}, textFieldProps, { className: `number-input-container ${props.className}`, error: error, InputLabelProps: { shrink: value ? true : false }, InputProps: getInputAdornments(), label: label, onChange: handleInput, value: value, variant: 'outlined' })))));
};
exports.default = exports.NumberInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnVtYmVySW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm9ybXMvTnVtYmVySW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLG9EQUEwQztBQUMxQywrQ0FJeUM7QUFDekMsNENBQXFEO0FBRXJELDRFQUUrRDtBQUMvRCxvREFBeUM7QUFDekMsNENBRXFEO0FBQ3JELDREQUFtRDtBQUduRCxJQUFZLGFBY1g7QUFkRCxXQUFZLGFBQWE7SUFDckIsOEJBQWEsQ0FBQTtJQUNiLDhCQUFnQixDQUFBO0lBQ2hCLCtCQUFpQixDQUFBO0lBQ2pCLHdCQUFhLENBQUE7SUFDYiw0QkFBZSxDQUFBO0lBQ2YsMEJBQWMsQ0FBQTtJQUNkLHdCQUFhLENBQUE7SUFDYiwwQkFBYyxDQUFBO0lBQ2QsMEJBQWMsQ0FBQTtJQUNkLDBCQUFjLENBQUE7SUFDZCwwQkFBYyxDQUFBO0lBQ2QsMEJBQWMsQ0FBQTtJQUNkLDBCQUFjLENBQUE7QUFDbEIsQ0FBQyxFQWRXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBY3hCO0FBeUJZLFFBQUEsV0FBVyxHQUFHLENBQUMsS0FBK0MsRUFBRSxFQUFFO0lBQzNFLE1BQU0sRUFDRixhQUFhLEdBQUcsSUFBSSxFQUNwQixhQUFhLEdBQUcsQ0FBQyxFQUNqQixLQUFLLEVBQUUsZ0JBQWdCLEdBQUcsS0FBSyxFQUMvQixZQUFZLEVBQ1osV0FBVyxFQUNYLEtBQUssRUFDTCxPQUFPLEVBQ1AsT0FBTyxFQUNQLFFBQVEsRUFDUixRQUFRLEdBQUcsS0FBSyxFQUNoQixjQUFjLEVBQ2QsSUFBSSxFQUNKLEtBQUssRUFDTCxLQUFLLEtBRUwsS0FBSyxFQURGLGNBQWMsVUFDakIsS0FBSyxFQWhCSCw2S0FnQkwsQ0FBUSxDQUFDO0lBRVYsTUFBTSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsR0FBRyxnQkFBUSxDQUFVLEtBQUssQ0FBQyxDQUFDO0lBQ25ELE1BQU0sQ0FBQyxZQUFZLEVBQUUsZUFBZSxDQUFDLEdBQUcsZ0JBQVEsRUFBc0IsQ0FBQztJQUN2RSxNQUFNLENBQUMsS0FBSyxFQUFFLFFBQVEsQ0FBQyxHQUFHLGdCQUFRLENBQVUsZ0JBQWdCLENBQUMsQ0FBQztJQUU5RCxNQUFNLG9CQUFvQixHQUFHLENBQUMsV0FBbUIsRUFBRSxFQUFFO1FBQ2pELElBQUksV0FBVyxJQUFJLElBQUksSUFBSSxNQUFNLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFO1lBQ2xELE9BQU8sSUFBSSxDQUFDO1NBQ2Y7UUFFRCxNQUFNLFNBQVMsR0FBRyxJQUFJLGdCQUFHLENBQUMsRUFBRSxDQUFDLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBRWpELE1BQU0sV0FBVyxHQUFHLGFBQWEsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFFbEQsTUFBTSxTQUFTLEdBQUcsSUFBSSxJQUFJLFdBQVcsQ0FBQztRQUV0QyxPQUFPLE1BQU0sQ0FBQyxJQUFJLGdCQUFHLENBQUMsV0FBVyxDQUFDLENBQUMsR0FBRyxDQUFDLFNBQVMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzdELENBQUMsQ0FBQTtJQUVELE1BQU0sV0FBVyxHQUFHLENBQUMsVUFBZSxFQUFFLEVBQUU7UUFDcEMsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBRWYsTUFBTSxLQUFLLEdBQUcsVUFBVSxDQUFDLE1BQU0sQ0FBQyxLQUFlLENBQUM7UUFFaEQsSUFBSSxRQUFRLEVBQUU7WUFDVixRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7U0FDbkI7SUFDTCxDQUFDLENBQUE7SUFFRCxNQUFNLGFBQWEsR0FBRyxDQUFDLEtBQXlCLEVBQUUsRUFBRTtRQUNoRCxNQUFNLFdBQVcsR0FBRyxVQUFVLENBQUMsS0FBSyxJQUFJLEVBQUUsQ0FBQyxDQUFDO1FBQzVDLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxLQUFLLElBQUksSUFBSSxJQUFJLEtBQUssS0FBSyxFQUFFLENBQUMsSUFBSSxRQUFRLEtBQUssS0FBSyxDQUFDO1FBRXBGLElBQUcsV0FBVyxLQUFLLEdBQUcsRUFBRTtZQUNwQixlQUFlLENBQUMsYUFBYSxLQUFLLHdCQUF3QixDQUFDLENBQUM7U0FDL0Q7YUFDSTtZQUNELE1BQU0scUJBQXFCLEdBQUcsZ0JBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxJQUFJLEVBQUUsRUFBRSxHQUFHLENBQUMsQ0FBQztZQUV4RCxNQUFNLHlCQUF5QixHQUFHO2dCQUM5QixXQUFXLEVBQUUsUUFBUSxJQUFJLEtBQUssSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLElBQUksS0FBSyxLQUFLLEVBQUUsQ0FBQztnQkFDakUsWUFBWSxFQUFFLGFBQWE7YUFDOUIsQ0FBQztZQUVGLDhCQUE4QjtZQUM5QixNQUFNLCtCQUErQixHQUFHO2dCQUNwQyxXQUFXLEVBQUUscUJBQXFCLENBQUMsTUFBTSxHQUFHLENBQUM7dUJBQzFDLENBQUMscUJBQXFCO2dCQUN6QixZQUFZLEVBQUUsZ0NBQWdDO2FBQ2pELENBQUM7WUFFRixtQ0FBbUM7WUFDbkMsTUFBTSw4QkFBOEIsR0FBRztnQkFDbkMsV0FBVyxFQUFFLGFBQWEsS0FBSyxLQUFLO3VCQUM3QixnQkFBQyxDQUFDLFFBQVEsQ0FBRSxLQUFLLEVBQUUsR0FBRyxDQUFFO3VCQUN4QixDQUFDLHFCQUFxQjt1QkFDdEIsS0FBSztnQkFDWixZQUFZLEVBQUUsdUJBQXVCO2FBQ3hDLENBQUM7WUFFRiw4QkFBOEI7WUFDOUIsTUFBTSx5QkFBeUIsR0FBRztnQkFDOUIsV0FBVyxFQUFFLGFBQWEsS0FBSyxJQUFJO3VCQUM1QixxQkFBcUIsQ0FBQyxNQUFNLEdBQUcsQ0FBQzt1QkFDaEMscUJBQXFCLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxHQUFHLGFBQWE7dUJBQy9DLENBQUMscUJBQXFCO3VCQUN0QixLQUFLO2dCQUNaLFlBQVksRUFBRSx5REFBeUQsYUFBYSxFQUFFO2FBQ3pGLENBQUM7WUFFRixrQkFBa0I7WUFDbEIsTUFBTSxrQkFBa0IsR0FBRztnQkFDdkIsV0FBVyxFQUFFLE9BQU8sSUFBSSxJQUFJO3VCQUNyQixXQUFXLEdBQUcsT0FBTzt1QkFDckIsQ0FBQyxxQkFBcUI7dUJBQ3RCLEtBQUs7Z0JBQ1osWUFBWSxFQUFFLHdDQUF3QyxPQUFPLEVBQUU7YUFDbEUsQ0FBQztZQUVGLG1CQUFtQjtZQUNuQixNQUFNLG1CQUFtQixHQUFHO2dCQUN4QixXQUFXLEVBQUcsT0FBTyxJQUFJLElBQUk7dUJBQ3RCLFdBQVcsR0FBRyxPQUFPO3VCQUNyQixDQUFDLHFCQUFxQjt1QkFDdEIsS0FBSztnQkFDWixZQUFZLEVBQUUseUNBQXlDLE9BQU8sRUFBRTthQUNuRSxDQUFDO1lBRUYsMkJBQTJCO1lBQzNCLE1BQU0seUJBQXlCLEdBQUc7Z0JBQzlCLFdBQVcsRUFBRSxJQUFJLElBQUksSUFBSTt1QkFDbEIsb0JBQW9CLENBQUMsV0FBVyxDQUFDLEtBQUssS0FBSzt1QkFDM0MsQ0FBQyxxQkFBcUI7dUJBQ3RCLEtBQUs7Z0JBQ1osWUFBWSxFQUFFLHVCQUF1QixJQUFJLGNBQWM7YUFDMUQsQ0FBQztZQUVGLG9EQUFvRDtZQUNwRCxNQUFNLG1CQUFtQixHQUFHO2dCQUN4QixXQUFXLEVBQUUsZ0JBQUMsQ0FBQyxRQUFRLENBQUUsV0FBVyxDQUFFLEtBQUssS0FBSzt1QkFDekMsQ0FBQyxxQkFBcUI7dUJBQ3RCLEtBQUs7Z0JBQ1osWUFBWSxFQUFFLHVCQUF1QjthQUN4QyxDQUFDO1lBRUYsTUFBTSxNQUFNLEdBQUc7Z0JBQ1gseUJBQXlCO2dCQUN6QiwrQkFBK0I7Z0JBQy9CLDhCQUE4QjtnQkFDOUIseUJBQXlCO2dCQUN6QixrQkFBa0I7Z0JBQ2xCLG1CQUFtQjtnQkFDbkIseUJBQXlCO2dCQUN6QixtQkFBbUI7YUFDQSxDQUFDO1lBRXhCLE1BQU0sYUFBYSxHQUFHLGdCQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFO2dCQUM3QyxPQUFPLEtBQUssQ0FBQyxXQUFXLENBQUM7WUFDN0IsQ0FBQyxDQUFDLENBQUM7WUFFSCxNQUFNLGNBQWMsR0FBRyxhQUFhLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQztZQUVoRCxJQUFJLGNBQWMsRUFBRTtnQkFDaEIsTUFBTSxXQUFXLEdBQUcsZ0JBQUMsQ0FBQyxHQUFHLENBQUMsYUFBYSxFQUFFLENBQUMsWUFBWSxFQUFFLEVBQUU7b0JBQ3RELE9BQU8sWUFBWSxDQUFDLFlBQVksQ0FBQztnQkFDckMsQ0FBQyxDQUFDLENBQUM7Z0JBRUgsTUFBTSxZQUFZLEdBQUcseUJBQXlCLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxHQUFHLEtBQUssY0FBYyxDQUFDLENBQUMsQ0FBQyxZQUFZLEtBQUssbUJBQW1CLFdBQVcsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQztnQkFFdkosZUFBZSxDQUFDLFlBQVksQ0FBQyxDQUFDO2FBQ2pDO2lCQUFNO2dCQUNILGVBQWUsQ0FBQyxFQUFFLENBQUMsQ0FBQzthQUN2QjtTQUNKO0lBQ0wsQ0FBQyxDQUFBO0lBRUQsaUJBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDWCxhQUFhLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDekIsQ0FBQyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDO0lBRTdCLGlCQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBSSxXQUFXLEVBQUU7WUFDYixXQUFXLENBQUMsS0FBSyxFQUFFLFlBQVksQ0FBQyxDQUFDO1NBQ3BDO0lBQ0wsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztJQUVaLGlCQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBRyxZQUFZLEtBQUssRUFBRSxJQUFJLFlBQVksSUFBSSxJQUFJLEVBQUU7WUFDNUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ25CO2FBQ0k7WUFDRCxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDbEI7SUFDTCxDQUFDLEVBQUUsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDO0lBRW5CLGlCQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsUUFBUSxDQUFDLGdCQUFnQixDQUFDLENBQUM7SUFDL0IsQ0FBQyxFQUFFLENBQUMsZ0JBQWdCLENBQUMsQ0FBQyxDQUFDO0lBRXZCLE1BQU0sa0JBQWtCLEdBQUcsR0FBeUIsRUFBRTtRQUNsRCxJQUFJLEtBQUssQ0FBQztRQUNWLElBQUksR0FBRyxDQUFDO1FBRVIsSUFBSSxjQUFjLEVBQUU7WUFDaEIsS0FBSyxHQUFHLGNBQWMsQ0FBQztTQUMxQjthQUNJLElBQUksS0FBSyxLQUFLLGFBQWEsQ0FBQyxPQUFPLEVBQUU7WUFDdEMsS0FBSyxHQUFHLDhCQUFDLHFCQUFjLElBQUMsUUFBUSxFQUFHLE9BQU8sUUFBbUIsQ0FBQztTQUNqRTtRQUVELElBQUksWUFBWSxFQUFFO1lBQ2QsR0FBRyxHQUFHLFlBQVksQ0FBQztTQUN0QjthQUNJLElBQUksS0FBSyxLQUFLLFNBQVMsSUFBSSxLQUFLLEtBQUssYUFBYSxDQUFDLE9BQU8sRUFBRTtZQUM3RCxHQUFHLEdBQUksOEJBQUMscUJBQWMsSUFBQyxRQUFRLEVBQUcsS0FBSyxJQUFFLEtBQUssQ0FBa0IsQ0FBQTtTQUNuRTtRQUVELE9BQU87WUFDSCxZQUFZLEVBQUksR0FBRztZQUNuQixjQUFjLEVBQUUsS0FBSztTQUN4QixDQUFBO0lBQ0wsQ0FBQyxDQUFBO0lBRUQsT0FBTyxDQUNILDhCQUFDLHVCQUFnQixJQUFDLEtBQUssRUFBRSxlQUFVO1FBQy9CLHVDQUFLLFNBQVMsRUFBRyxpQkFBaUI7WUFDOUIsOEJBQUMsbUJBQVMsb0JBQ0YsY0FBYyxJQUNsQixTQUFTLEVBQVUsMEJBQTBCLEtBQUssQ0FBQyxTQUFTLEVBQUUsRUFDOUQsS0FBSyxFQUFlLEtBQUssRUFDekIsZUFBZSxFQUFJLEVBQUUsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFDbkQsVUFBVSxFQUFVLGtCQUFrQixFQUFFLEVBQ3hDLEtBQUssRUFBZSxLQUFLLEVBQ3pCLFFBQVEsRUFBWSxXQUFXLEVBQy9CLEtBQUssRUFBZSxLQUFLLEVBQ3pCLE9BQU8sRUFBVyxVQUFVLElBQzlCLENBQ0EsQ0FDUyxDQUN0QixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsbUJBQVcsQ0FBQyJ9